import { render } from "./BankDetailsData.vue?vue&type=template&id=7a22a428"
import script from "./BankDetailsData.vue?vue&type=script&lang=js"
export * from "./BankDetailsData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__